import React from 'react';
import { Card, CardContent, CardHeader } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useLimitations } from './useLimitations';
import LimitationsContent from './LimitationsContent';
import SummaryParagraphHeader from '../SummaryParagraphHeader';

const useStyles = makeStyles((theme) => ({
  card_main_container: {
    margin: '0',
    borderRadius: '5px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
}));

export default function Limitations() {
  const { t } = useTranslation();
  const theme = useTheme();
  const classes = useStyles();

  const {
    limitations,
    newTitle,
    newDescription,
    showAddSection,
    handleToggle,
    handleDelete,
    handleAdd,
    handleToggleAddSection,
    setNewTitle,
    setNewDescription,
    resetAddForm,
  } = useLimitations(true, null, true);

  return (
    <Card
      className={classes.card_main_container}
      style={{
        height: '100%',
      }}>
      <CardHeader
        style={{
          padding: '0',
          backgroundColor: theme.palette.texts.generalTitleBackgrounds,
          height: '38px',
        }}
        title={
          <div
            style={{
              display: 'flex',
              width: '100%',
              padding: '0px 8px',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}>
            <SummaryParagraphHeader header={t('ResultView.Notes')} tootlipTitle={t('ResultView.Notes')} />
          </div>
        }
      />

      <CardContent
        style={{
          padding: '0',
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          flexDirection: 'column',
          overflow: 'auto',
          minHeight: '70%',
        }}>
        <LimitationsContent
          limitations={limitations}
          newTitle={newTitle}
          newDescription={newDescription}
          showAddSection={showAddSection}
          handleToggle={handleToggle}
          handleDelete={handleDelete}
          handleAdd={handleAdd}
          handleToggleAddSection={handleToggleAddSection}
          setNewTitle={setNewTitle}
          setNewDescription={setNewDescription}
          resetAddForm={resetAddForm}
          variant='card'
        />
      </CardContent>
    </Card>
  );
}
